import { useEffect, useState } from 'react';
import { api, datum, menge, zeitpunkt, type Anmelder }
  from '../api.ts';
import { Kopf, Karte, Kachel, Leer } from '../teile/Geruest.tsx';

const STATUS: Record<string, string> = {
  offen: 'offen', eingereicht: 'eingereicht', abgeschlossen: 'abgeschlossen',
};

export default function Abrechnung({
  ich, oeffne,
}: { ich: Anmelder; oeffne: (id: string, reiter?: string) => void }) {
  const [d, setD] = useState<any>(null);
  const [reiter, setReiter] =
    useState<'auftraege' | 'positionen' | 'leb' | 'einblasstop'>('auftraege');
  const [fehler, setFehler] = useState<string | null>(null);
  useEffect(() => { api.abrechnung().then(setD).catch((f) => setFehler(f.message)); }, []);

  if (fehler) return <div className="inhalt"><div className="hinweis fehler">{fehler}</div></div>;
  if (!d) return null;

  return (
    <>
      {/* DER BILDSCHIRM HEISST FÜR DEN SUB ANDERS, WEIL ER ETWAS ANDERES IST.
          Für den Innendienst ist er die Abrechnungswerkbank; für eine
          Partnerfirma ist er die Liste der eigenen Aufmaße. Bis zum
          26.08.2026 war er für sie ein roter Kasten: der Menüpunkt erschien
          mit `aufmass.erfassen`, der Datenweg dahinter verlangte
          `aufmass.pruefen`. */}
      <Kopf titel={d.istSub ? 'Meine Aufmaße' : 'Aufmaß und Abrechnung'}
            weg={d.istSub ? 'Was erfasst ist, was noch offen steht'
                          : 'Mengen, Prüfung, LEB für eVergabe'} />
      <div className="inhalt">

        <div className="kachelreihe">
          <Kachel wert={d.zahlen.auftraege} was="Aufträge mit Aufmaß" />
          <Kachel wert={d.zahlen.positionen} was="Positionen" />
          <Kachel wert={d.zahlen.eingereicht} was="eingereicht, noch nicht geprüft" />
          <Kachel wert={d.zahlen.offen} was="Positionen noch nicht abgerechnet" />
          {!d.istSub && (
            <>
              <Kachel wert={d.zahlen.leb_dateien} was="erzeugte LEB-Dateien" />
              <Kachel wert={d.zahlen.ohne_belegnummer} was="ohne Belegnummer"
                      farbe={d.zahlen.ohne_belegnummer ? 'var(--ueberfaellig)' : undefined} />
            </>
          )}
        </div>

        {/* SIE BLEIBT BEIM ROLLEN OBEN STEHEN (`.reiterreihe`). Der
            Aussenrand steht nicht mehr als Inline-Stil da: er würde die
            negativen Seitenränder der klebenden Leiste überschreiben, und
            dann liefe die Liste links und rechts an ihr vorbei. */}
        <div className="reihe reiterreihe">
          {([['auftraege', `Aufträge (${d.auftraege.length})`],
             /* DIE MENGEN JE POSITION STEHEN SEIT .230 IN DER AUSWERTUNG
                (gegliedert nach Ort, ONKZ, Gemeinde, Firma, Monat). Marvin:
                „die mengen mit positionen kommt in die auswertung rein."
                Eine Partnerfirma hat keine Auswertung und behält hier die
                Summe ihrer eigenen Mengen. */
             ...(d.istSub ? [['positionen', `Mengen je Position (${d.jeOz.length})`] as const] : []),
             /* Die LEB-Datei trägt UNSERE Mengen und unsere Belegnummer und
                liegt ausdrücklich ausserhalb des Auftragsordners. Für eine
                Partnerfirma gibt es diesen Reiter nicht. */
             ...(d.istSub ? [] : [['leb', `LEB-Dateien (${d.leb.length})`] as const]),
             /* HIER STAND „Rechnungen der Subs", und die Begründung dafür
                lautete: „es ist dieselbe Frage wie beim Aufmaß, nur von der
                anderen Seite." Das stimmt fachlich und war für die Bedienung
                falsch. Marvin, 21.09.2026: „wo ist denn der menüpunkt um die
                rechnungen gegenzuprüfen? dafür brauche ich einen extra
                punkt." **Ein Bildschirm, den man nur findet, wenn man weiss,
                wo er liegt, ist für jeden anderen nicht vorhanden.** Er hat
                seit .176 seinen eigenen Menüpunkt „Rechnungen prüfen". */
             /* DIE EINBLASSTOPPS SIND SEIT .230 EIN FILTER UNTER „AUFTRÄGE"
                („Was ansteht" → Einblasstopp). Marvin: „warum stehen hier die
                einblasstops. das wäre ein filterpunkt unter "Aufträgen"". */
            ] as const).map(([r, t]) => (
            <button key={r} className="knopf" onClick={() => setReiter(r as any)}
              style={reiter === r ? { borderColor: 'var(--akzent)', color: 'var(--akzent)' } : undefined}>
              {t}
            </button>
          ))}
        </div>

        {reiter === 'auftraege' && (
          <div className="karte">
            {/* AUCH HIER ROLLT SIE IN IHRER KARTE, aus demselben Grund wie in
                der Arbeitsliste: eine Tabelle direkt unter `.karte` hat auf
                dem Telefon keinen rollenden Vorfahren und wird abgeschnitten. */}
            <div className="rollt">
            <table className="liste">
              <thead>
                <tr>
                  <th>Baustelle</th>
                  {!d.istSub && <th style={{ width: 180 }}>Tiefbaufirma</th>}
                  <th style={{ width: 120 }}>Aufmaß</th>
                  <th style={{ width: 120 }}>Montage</th>
                  <th className="zahl" style={{ width: 80 }}>Pos.</th>
                  <th className="zahl" style={{ width: 80 }}>offen</th>
                  {!d.istSub && <th className="zahl" style={{ width: 70 }}>LEB</th>}
                </tr>
              </thead>
              <tbody>
                {d.auftraege.map((a: any) => (
                  <tr key={a.id} onClick={() => oeffne(a.id)}>
                    <td>
                      {a.strasse} {a.hausnummer}
                      <div className="leise klein">
                        {a.plz} {a.ort_text}
                        {!d.istSub && !a.belegnummer && (
                          <span style={{ color: 'var(--ueberfaellig)' }}>, keine Belegnummer</span>
                        )}
                      </div>
                    </td>
                    {!d.istSub && (
                      <td className="klein">
                        {a.tiefbaufirma ?? <span className="leise">keine</span>}
                      </td>
                    )}
                    <td className="klein">
                      <span className={'marke-zustand ' + (
                        a.aufmass_status === 'abgeschlossen' ? 'z-erledigt'
                        : a.aufmass_status === 'eingereicht' ? 'z-laufend' : 'z-unterbrochen')}>
                        {STATUS[a.aufmass_status]}
                      </span>
                      {a.aufmass_eingereicht_am && (
                        <div className="leise" style={{ marginTop: 3 }}>
                          {datum(a.aufmass_eingereicht_am)}
                        </div>
                      )}
                    </td>
                    <td className="klein">
                      <span className={'marke-zustand ' + (
                        a.montage_status === 'abgeschlossen' ? 'z-erledigt'
                        : a.montage_status === 'eingereicht' ? 'z-laufend' : 'z-unterbrochen')}>
                        {STATUS[a.montage_status]}
                      </span>
                    </td>
                    <td className="zahl">{a.positionen}</td>
                    <td className="zahl" style={{ color: a.offene_positionen ? 'var(--neu)' : undefined }}>
                      {a.offene_positionen || ''}
                    </td>
                    {!d.istSub && <td className="zahl">{a.leb_dateien || ''}</td>}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}

        {reiter === 'positionen' && (
          <Karte titel="Erfasste Mengen je Leistungsposition"
                 rechts={d.istSub ? undefined
                   : <span className="intern-hinweis">geprüfte Menge, intern</span>}>
            <table className="liste">
              <thead>
                <tr>
                  <th style={{ width: 100 }}>OZ</th><th>Leistung</th>
                  <th className="zahl" style={{ width: 110 }}>Menge</th>
                  <th className="zahl" style={{ width: 80 }}>Zeilen</th>
                </tr>
              </thead>
              <tbody>
                {d.jeOz.map((p: any) => (
                  <tr key={p.oz} style={{ cursor: 'default' }}>
                    <td className="klein">{p.oz}</td>
                    <td>{p.text}</td>
                    <td className="zahl">{menge(p.menge, p.einheit)}</td>
                    <td className="zahl leise">{p.zeilen}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="klein leise" style={{ marginBottom: 0, marginTop: 10 }}>
              Es steht kein Preis dabei, und das bleibt so. Das System liefert
              Mengen, gerechnet wird außerhalb.
              {d.istSub && ' Gezeigt sind Ihre gemeldeten Mengen.'}
            </p>
          </Karte>
        )}

        {reiter === 'leb' && (
          <Karte titel="Erzeugte LEB-Dateien">
            {d.leb.length === 0 ? <Leer text="Noch keine Datei erzeugt." /> : (
              <table className="liste">
                <thead>
                  <tr>
                    <th style={{ width: 100 }}>Art</th><th>Baustelle</th>
                    <th style={{ width: 130 }}>Belegnummer</th>
                    <th style={{ width: 190 }}>Leistungszeitraum</th>
                    <th className="zahl" style={{ width: 80 }}>Pos.</th>
                    <th style={{ width: 130 }}>erzeugt</th>
                  </tr>
                </thead>
                <tbody>
                  {d.leb.map((l: any) => (
                    <tr key={l.id} style={{ cursor: 'default' }}>
                      <td>
                        <span className={'marke-zustand ' + (l.art === 'teil' ? 'z-laufend' : 'z-erledigt')}>
                          {l.art}
                        </span>
                      </td>
                      <td>{l.strasse} {l.hausnummer}</td>
                      <td className="klein leise">{l.belegnummer}</td>
                      <td className="klein">{datum(l.lz_von)} bis {datum(l.lz_bis)}</td>
                      <td className="zahl">{l.positionen}</td>
                      <td className="klein leise">{zeitpunkt(l.erzeugt_am)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Karte>
        )}

        {/* DIE RECHNUNGSPRÜFUNG IST HIER AUSGEZOGEN (21.09.2026).
            Marvin: „wo ist denn der menüpunkt um die rechnungen
            gegenzuprüfen? dafür brauche ich einen extra punkt." Sie war der
            4. Reiter und damit für jeden, der sie suchte, nicht vorhanden.
            **Sie steht jetzt an EINER Stelle und nicht an zweien**: zwei Orte
            für denselben Bildschirm sind zwei Orte, an denen jemand einen
            Haken setzt. Der Einblasstop bleibt hier - er ist eine Aussage
            über das Aufmaß und keine über eine Rechnung. */}

      </div>
    </>
  );
}
